var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h18zM8.515 12.8s-.305.274-1.015.274-1.015-.274-1.015-.274c-1.993.254-2.39.644-2.468 1.898l-.007.143-.005.15a5.22 5.22 0 0 1-.003.104L4 15.107l-.001.16c.035.044.609.733 3.5.733s3.465-.689 3.498-.732l.002-.002v-.117l-.004-.108c-.034-1.53-.317-1.965-2.481-2.241zM19 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM7.5 8c-1.659 0-1.945.985-1.945 2.2 0 1.215.871 2.2 1.945 2.2s1.944-.985 1.944-2.2C9.444 8.985 9.16 8 7.5 8zM19 9h-4a1 1 0 0 0-.117 1.993L15 11h4a1 1 0 0 0 0-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembercard);
export default __webpack_public_path__ + "static/media/membercard.05deb49b.svg";
export { ForwardRef as ReactComponent };